import { StimulationPopup } from "../StimulationPopup/StimulationPopup.js"
import { Search } from "../Search/Search.js"

// Инициализируем всплывающее окно
const stimulationPopup = new StimulationPopup()
window.stimulationPopup = stimulationPopup

// Инициализируем поиск
const search = new Search()
window.search = search

import { Form } from "../Form/Form.js";
const form = new Form();
window.form = form;

import { Lead } from "../lead/lead.js";
const lead = new Lead();
window.lead = lead;

// Resize
$(window).on("resize", function () {

});


// Scroll
$(window).on("scroll", function () {

})

function adjustMenuLayout() {
	const menu = document.querySelector('.header-menu-list');
	if (!menu) return;

	const items = Array.from(menu.children).filter(el => el.offsetParent !== null);
	if (items.length === 0) return;

	const firstRowTop = items[0].offsetTop;
	const isSingleRow = items.every(item => item.offsetTop === firstRowTop);

	menu.style.justifyContent = isSingleRow ? 'space-between' : 'auto';
}

window.addEventListener('load', adjustMenuLayout);
window.addEventListener('resize', adjustMenuLayout);

$(document).ready(function() {
	var pageTitle = $("#pageTitle").text();
	$("<li>").text(pageTitle).appendTo("#dynamicBreadcrumb");
});

$(function () {
	function fixRutubeShorts() {
		$('iframe[src*="rutube.ru/shorts/"]').each(function () {
			const $iframe = $(this);
			const src = $iframe.attr('src');
			if (!src.includes('/play/embed/')) {
				const fixedSrc = src.replace('rutube.ru/shorts/', 'rutube.ru/play/embed/');
				$iframe.attr('src', fixedSrc);
			}
		});
	}

	// Запускаем сразу после загрузки
	fixRutubeShorts();

	// И следим за динамически добавленными блоками
	const observer = new MutationObserver(() => fixRutubeShorts());
	observer.observe(document.body, { childList: true, subtree: true });
});

//HEADER//
$(document).ready(function() {
	// Показываем или скрываем все скрытые элементы при клике на кнопку
	$(".hidden-list-item").hide();
	$(".show-hidden-links").click(function() {
		$(".hidden-list-item").fadeToggle(); // Плавно переключаем видимость всех скрытых элементов
		$(this).find('.show-icon, .hide-icon').toggle(); // Переключаем иконки
	});
});
//HEADER//

let menuBtn = document.querySelector('.header-main__info-burger');
let menu = document.querySelector('.header-main__info-block');
// let headWrapper = document.querySelector('.header-wrapper');
let body = document.querySelector('body');
// let socialBtn = document.querySelector('.social-burger');

menuBtn.addEventListener('click', function(){
	menuBtn.classList.toggle('active');
	// headWrapper.classList.toggle('active');
	menu.classList.toggle('active');
	body.classList.toggle('no-scroll');
});

//accordion//
$(function () {
	// === 1. Клик работает только по .accordion-block-item-header ===
	$('.accordion-block-item-header').on('click', function (e) {
		const $item = $(this).closest('.accordion-block-item')
		const $content = $item.find('.accordion-block-item-content')

		// Закрыть другие
		$('.accordion-block-item-content').not($content).slideUp(300).removeClass('active')

		// Переключить текущий
		if ($content.hasClass('active')) {
			$content.removeClass('active').slideUp(300)
		} else {
			$content.addClass('active').slideDown(300)
		}
	})

	// === 2. Автооткрытие по URL (?section=accordion-3 или ?accordion-3) ===
	const search = window.location.search
	let sectionId = new URLSearchParams(search).get('section')
	if (!sectionId && search.startsWith('?accordion-')) {
		sectionId = search.slice(1)
	}

	if (sectionId) {
		const $block = $('#' + sectionId)
		if ($block.length) {
			setTimeout(() => {
				$block.find('.accordion-block-item-header').trigger('click')

				// Автоскролл
				setTimeout(() => {
					const offset = $block.offset().top
					$('html, body').animate({ scrollTop: offset - 100 }, 500)
				}, 350)
			}, 300)
		}
	}
})
//accordion//

//form-mail//
$(function () {
	const $form = $('#request-form');

	$('a[href="#request-form"]').on('click', function (e) {
		e.preventDefault();
		$form.slideDown(300);

		// если хочешь — прокрутим к форме
		$('html, body').animate({
			scrollTop: $form.offset().top - 100
		}, 400);
	});
});
//form-mail//

//statistics//
// Функция для анимированного изменения чисел
function animateNumbers(element, finalNumber, duration) {
	let start = 0;
	let startTime = null;
	element.classList.remove('animated');

	function step(timestamp) {
		if (!startTime) startTime = timestamp;
		const progress = timestamp - startTime;
		const increment = finalNumber * (progress / duration);
		if (increment < finalNumber) {
			element.textContent = Math.ceil(increment).toLocaleString();
			requestAnimationFrame(step);
		} else {
			element.textContent = finalNumber.toLocaleString();
			element.classList.add('animated'); // Добавляем класс, чтобы запретить повторную анимацию
		}
	}

	requestAnimationFrame(step);
}

// Функция для проверки видимости элемента при прокрутке и запуска анимации
function checkVisibilityAndAnimate(elements) {
	elements.forEach(element => {
		const rect = element.getBoundingClientRect();
		const windowHeight = window.innerHeight || document.documentElement.clientHeight;

		if (rect.top >= 0 && rect.bottom <= windowHeight && !element.classList.contains('animated')) {
			const finalNumber = parseInt(element.getAttribute('data-final-number'), 10);
			animateNumbers(element, finalNumber, 3000); // 3000 - продолжительность анимации в миллисекундах
		}
	});
}

// Обработчик события scroll и resize
function handleScrollAndResize() {
	const h2Elements = document.querySelectorAll(".statistics-block-list li h2");
	const h3Elements = document.querySelectorAll(".statistics-preview-block-list li h3");
	
	checkVisibilityAndAnimate(h2Elements);
	checkVisibilityAndAnimate(h3Elements);
}

window.addEventListener('scroll', handleScrollAndResize);
window.addEventListener('resize', handleScrollAndResize);
window.addEventListener('load', handleScrollAndResize); // Для случаев, когда страница загружается сразу в середине блока

//statistics//

//form//
// Обработчик события отправки формы теперь в классе Form

document.addEventListener('DOMContentLoaded', function () {
	// Функция для активации/деактивации текстового поля при выборе/сбросе чекбокса "Другое (указать)"
	function toggleOtherTextarea(checkbox, textarea) {
		textarea.disabled = !checkbox.checked;
		if (checkbox.checked) {
			textarea.focus();
		}
	}

	// Обработчики для всех вопросов с чекбоксом "Другое (указать)"

	// var otherCheckboxes = document.querySelectorAll('input[type="checkbox"][id^="other_"]');
	var otherCheckboxes = document.querySelectorAll('.answer-block[id$="other"] input[type="checkbox"]');
	// var otherTextareas = document.querySelectorAll('textarea[id^="other_"]');
	var otherTextareas = document.querySelectorAll('textarea[id$="_description"]');
	
	otherCheckboxes.forEach(function (checkbox, index) {
		checkbox.addEventListener('change', function () {
			toggleOtherTextarea(this, otherTextareas[index]);
		});
	});
});

document.addEventListener('DOMContentLoaded', function () {
	// Получаем все чекбоксы "нет"
	// var noCheckboxes = document.querySelectorAll('.answer-block input[type="checkbox"][value="нет"]');
	var noCheckboxes = document.querySelectorAll('.answer-block input[type="checkbox"][value="нет"]');
	
	// Добавляем обработчик события change для каждого чекбокса "нет"
	noCheckboxes.forEach(function (checkbox) {
		checkbox.addEventListener('change', function () {
			// Если чекбокс "нет" выбран
			if (this.checked) {
				// Получаем родительский элемент списка ответов
				var answerBlock = this.closest('.answer');
				// Получаем все чекбоксы в этом списке ответов, кроме текущего чекбокса "нет"
				// var otherCheckboxes = answerBlock.querySelectorAll('.answer-block input[type="checkbox"]:not([value="нет"])');
				var otherCheckboxes = answerBlock.querySelectorAll('.answer-block input[type="checkbox"]:not([value="' + this.value + '"])');
				
				// Сбрасываем выбранные значения других чекбоксов в текущем списке ответов
				otherCheckboxes.forEach(function (otherCheckbox) {
					otherCheckbox.checked = false;
				});
			}
		});
	});

	// Добавляем обработчик события change для каждого чекбокса, кроме "нет"
	// Обработчик для всех чекбоксов, кроме "нет"
	var allCheckboxesExceptNo = document.querySelectorAll('.answer-block input[type="checkbox"]:not([value="нет"])');
	allCheckboxesExceptNo.forEach(function (checkbox) {
		checkbox.addEventListener('change', function () {
			if (this.checked) {
				var answerBlock = this.closest('.answer');
				var noCheckbox = answerBlock.querySelector('.answer-block input[type="checkbox"][value="нет"]');

				if (noCheckbox && noCheckbox.checked) {
					noCheckbox.checked = false;
				}
			}
		});
	});
});

// document.getElementById('uploadButton').addEventListener('click', function() {
// 	var fileInput = document.createElement('input');
// 	fileInput.type = 'file';
// 	fileInput.multiple = true;
// 	fileInput.style.display = 'none';
// 	fileInput.addEventListener('change', function() {
// 		var fileList = document.getElementById('fileList');
// 		var files = this.files;
// 		for (var i = 0; i < files.length; i++) {
// 			var li = document.createElement('li');
// 			li.className = 'fileItem';
// 			li.innerHTML = `
// 			<span>${files[i].name}</span>
// 			<button class="deleteButton" type="button"><svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
// 			<path d="M1 1L13 13M13 1L1 13" stroke="Black" stroke-linecap="round"/>
// 			</svg>
// 			</button>
// 			`;
// 			fileList.appendChild(li);
// 		}
// 		// Отправка файлов на сервер
// 		var formData = new FormData();
// 		for (var i = 0; i < files.length; i++) {
// 			formData.append('files[]', files[i]);
// 		}
// 		// Пример отправки formData на сервер с использованием fetch
// 		fetch('/upload', {
// 			method: 'POST',
// 			body: formData
// 		})
// 		.then(response => response.json())
// 		.then(data => console.log(data))
// 		.catch(error => console.error('Ошибка:', error));
// 		// Удаление input после загрузки файлов
// 		this.remove();

// 		// Добавление обработчика для кнопок удаления файлов
// 		addDeleteButtonHandlers();
// 	});
// 	document.body.appendChild(fileInput);
// 	fileInput.click();
// });

function addDeleteButtonHandlers() {
	document.querySelectorAll('.deleteButton').forEach(button => {
		button.addEventListener('click', function() {
			this.closest('.fileItem').remove();
			// Здесь можно добавить логику удаления файла с сервера
		});
	});
}

  // Добавление обработчика для кнопок удаления файлов на странице загрузки
addDeleteButtonHandlers();

document.addEventListener('DOMContentLoaded', function () {
	const agreeCheckbox = document.getElementById('agreeCheckbox');
	const submitButton = document.getElementById('submitButton');

	if (!agreeCheckbox || !submitButton) {
		console.warn("Элементы не найдены: agreeCheckbox или submitButton");
		return; // Прерываем выполнение, чтобы не было ошибки
	}

	agreeCheckbox.addEventListener('change', function () {
		submitButton.disabled = !this.checked;
	});
});

//form//

//popups//
$(".popup__close, .popup__cancel").on("click", function (e) {
	$("body").removeClass("no-scroll");
	$(this).closest(".popup").removeClass("active");
});

$(".popup").on("click", function (e) {
	var callbackPopup = $(".popup__card")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass("active");
		$("body").removeClass("no-scroll");
	};
});

$("[data-popup-open]").on("click", function (e) {
	e.preventDefault();
	let dataPopupName = $(this).attr("data-popup-open");
	let popup = $(".popup[data-popup-name=" + dataPopupName + "]");
	$("body").addClass("no-scroll");
	popup.addClass("active");
});
//popups//

//MEDIA//
$(document).ready(function() {
	// Добавляем класс no-click к iframe при ширине окна 768 пикселей или менее
	if ($(window).width() <= 768) {
		$('.media-block-swiper .swiper-wrapper .swiper-slide iframe').addClass('no-click');
	}

	// Обработчик события касания на родителе iframe
	$('.media-block-swiper ul li').on('touchstart', function() {
		// Проверяем, есть ли у родителя iframe класс .no-click
		if ($(this).find('iframe').hasClass('no-click')) {
			// Удаляем класс no-click после первого касания на мобильном устройстве
			$(this).find('iframe').removeClass('no-click');
		}
	});
});

//MEDIA//

//MAPS//
$('.mapContainer').each(function() {
	var mapTitle = $('<div>').addClass('mapTitle');
	mapTitle.text('Для активации карты нажмите по ней');
	$(this).append(mapTitle);

	$(this).on('click', function() {
		$(this).children(':first').removeAttr('style');
		mapTitle.remove();
	});

	$(this).on('mousemove', function(event) {
		mapTitle.css('display', 'block');
		if (event.offsetY > 10) mapTitle.css('top', event.offsetY + 20 + 'px');
		if (event.offsetX > 10) mapTitle.css('left', event.offsetX + 20 + 'px');
	});

	$(this).on('mouseleave', function() {
		mapTitle.css('display', 'none');
	});
});
//MAPS//

//IFRAME//
$(document).ready(function () {
  function processIframe(iframe) {
    $(iframe).on('load', function () {
      try {
        const innerDoc = this.contentDocument || this.contentWindow.document;
        const videos = innerDoc.querySelectorAll('video');

        videos.forEach(video => {
          // Отключаем автоплей
          video.autoplay = false;
          video.removeAttribute('autoplay');
          video.pause();

          // Убираем жесткие размеры
          video.style.setProperty('min-width', '0', 'important');
          video.style.setProperty('min-height', '0', 'important');
          video.style.setProperty('width', '100%', 'important');
          video.style.setProperty('height', 'auto', 'important');
          video.style.setProperty('max-width', '100%', 'important');

          // Принудительно обновляем layout
          video.style.display = 'none';
          // Триггер перерисовки
          void video.offsetHeight;
          video.style.display = '';
        });
      } catch (e) {
        console.warn('Не удалось обработать iframe:', e);
      }
    });
  }

  // Обрабатываем все текущие iframe
  $('iframe').each(function () {
    processIframe(this);
  });

  // Следим за новыми iframe
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      $(mutation.addedNodes).each(function () {
        if (this.tagName === 'IFRAME') {
          processIframe(this);
        } else {
          $(this).find('iframe').each(function () {
            processIframe(this);
          });
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

//CUSTOM VIDEO PLAYER//
document.addEventListener('DOMContentLoaded', function() {
	const videoPlayers = document.querySelectorAll('.custom-video-player');
	
	videoPlayers.forEach(function(player) {
		const preview = player.querySelector('.video-preview');
		const video = player.querySelector('.video-element');
		const thumbnail = player.querySelector('.video-thumbnail');
		
		// Функция для генерации превью
		function generateThumbnail() {
			// Сразу используем клиентскую генерацию
			generateClientThumbnail();
		}
		
		// Функция для клиентской генерации превью
		function generateClientThumbnail() {
			// Видео уже должно быть готово к этому моменту
			if (video.readyState < 2) {
				player.querySelector('.thumbnail-loading').classList.remove('active');
				return;
			}
			
			try {
				// Создаем canvas для генерации превью
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				canvas.width = 320;
				canvas.height = 180;
				
				// Устанавливаем время для превью (секунда 1)
				video.currentTime = 1;
				
				video.addEventListener('seeked', function() {
					try {
						// Рисуем кадр из видео на canvas
						ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
						
						// Конвертируем в base64
						const thumbnailData = canvas.toDataURL('image/jpeg', 0.9);
						
						// Применяем превью
						thumbnail.src = thumbnailData;
						thumbnail.style.display = 'block';
						player.querySelector('.thumbnail-loading').classList.remove('active');
					} catch (e) {
						// Если не удалось сгенерировать, показываем заглушку
						thumbnail.src = '/media/video-placeholder.svg';
						player.querySelector('.thumbnail-loading').classList.remove('active');
					}
				}, { once: true });
				
				// Обработчик ошибок при загрузке видео
				video.addEventListener('error', function() {
					thumbnail.src = '/media/video-placeholder.svg';
					player.querySelector('.thumbnail-loading').classList.remove('active');
				}, { once: true });
				
			} catch (e) {
				thumbnail.src = '/media/video-placeholder.svg';
				player.querySelector('.thumbnail-loading').classList.remove('active');
			}
		}
		
		// Более надежная система загрузки превью
		function initThumbnail() {
			const loadingIndicator = player.querySelector('.thumbnail-loading');
			
			// Показываем заглушку сразу
			thumbnail.src = '/media/video-placeholder.svg';
			thumbnail.style.display = 'block';
			
			// Показываем индикатор загрузки
			loadingIndicator.classList.add('active');
			
			// Ждем полной загрузки видео перед генерацией превью
			waitForVideoLoad();
		}
		
		// Функция ожидания полной загрузки видео
		function waitForVideoLoad() {
			if (video.readyState >= 3) {
				// Видео полностью загружено
				generateThumbnail();
			} else {
				// Ждем полной загрузки
				video.addEventListener('canplaythrough', generateThumbnail, { once: true });
				video.addEventListener('loadedmetadata', () => {
					// Дополнительная проверка через небольшую задержку
					setTimeout(() => {
						if (video.readyState >= 2) {
							generateThumbnail();
						}
					}, 500);
				}, { once: true });
			}
		}
		
		// Запускаем инициализацию
		if (video.readyState >= 2) {
			// Видео уже частично загружено
			initThumbnail();
		} else {
			// Ждем начала загрузки видео
			video.addEventListener('loadeddata', initThumbnail, { once: true });
			video.addEventListener('canplay', initThumbnail, { once: true });
		}
		
		// Обработчик клика по превью
		preview.addEventListener('click', function() {
			preview.style.display = 'none';
			video.style.display = 'block';
			video.play().catch(function(e) {
				console.log('Ошибка воспроизведения:', e);
			});
		});
		
		// Обработчик окончания видео
		video.addEventListener('ended', function() {
			preview.style.display = 'block';
			video.style.display = 'none';
		});
		
		// Обработчик ошибок видео
		video.addEventListener('error', function() {
			// Ошибка загрузки видео
		});
	});
});
//CUSTOM VIDEO PLAYER//